<template>
  <div class="-new">
    <div class="c_main -pad-btm">
			<div class="inner">
				<nav class="c_pnkz">
					<ul class="c_pnkz_list">
						<li><a href="/">ホーム</a></li>
						<li>新着コンテンツ</li>
					</ul>
				</nav>
				<section class="serach">
					<h1 class="serach_ttl">新着コンテンツ</h1>
          <contents-list :contents="contents"></contents-list>
          <div :class="{c_load: loading}"></div>
					<paginate
            v-if="contents.length"
						v-model="page"
            :page-count="getPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'&lt; 前へ'"
            :next-text="'次へ &gt;'"
            :container-class="'c_pager'"
						:prev-link-class="'-prev'"
						:next-link-class="'-next'"
						no-li-surround
            >
          </paginate>
				</section>
			</div>
		</div>
  </div>
</template>

<script>
import ContentsList from "@/components/ContentsList";
export default {
  components: {
    ContentsList,
  },
	data() {
    return {
			contents: [],
			total: 0,
			loading: false,
			page: 1,
    }
	},
	computed: {
		getPageCount: function() {
      return Math.ceil(this.total / 5);
    }
	},
  created() {
    this.fetch()
  },
  methods: {
		fetch() {
      this.contents = []
      this.loading = true

      let params = { page: this.page }
      this.$authAxios.get('/api/contents/new', {
				params: params
      })
      .then((response) => {
				this.contents = response.data.result
				this.total = response.data.count
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false
      })
		},
		clickCallback(pageNum) {
      window.scrollTo({top:0, behavior: "instant"})
			this.page = Number(pageNum)
			this.fetch()
    },
  }
}
</script>

<style scoped>
@import "~@/css/search.css";
</style>